var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSmallArrowRight = function SvgSmallArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262A30",
    fillRule: "nonzero",
    d: "M.07.598V3.58l3.696 2.072L.07 7.738v2.954l6.86-3.808V4.392z"
  })));
};
export default SvgSmallArrowRight;